export default (isOpen) => ({
    isOpen:isOpen,
    init: function() {
        this.$watch('isOpen', (isOpen) => {
            Alpine.store('modal').isOpen = isOpen;
        });
        Livewire.on('openModal', config => {
            if(!config.component?.name) {
                return console.error(`The property component name is required [
                    'component' => [
                        'name' => <livewire component>, //required
                        'params' => [livewire component params...], //optional
                    ]
                    'resource' => [ //optional
                        'maxWidth' => xl, //default=2xl
                        'centered' => true, //default=false
                    ]
                ]"`)
            }

            if(config.resource) {
                const {maxWidth, centered} = config.resource;

                Alpine.store('modal').maxWidth = maxWidth ?? Alpine.store('modal').maxWidth;
                Alpine.store('modal').centered = centered ?? Alpine.store('modal').centered;
            }
            Livewire.dispatch('modal::open', { viewName: config.component.name, params: config.component.params });
        });

        Livewire.on('closeModal', () => {
            Livewire.dispatch('modal::close');
        });
    },
    focusables() {
        // All focusable element types...
        let selector = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex=\'-1\'])'
        return [...$el.querySelectorAll(selector)]
            // All non-disabled elements...
            .filter(el => ! el.hasAttribute('disabled'))
    },
    firstFocusable() { return this.focusables()[0] },
    lastFocusable() { return this.focusables().slice(-1)[0] },
    nextFocusable() { return this.focusables()[this.nextFocusableIndex()] || this.firstFocusable() },
    prevFocusable() { return this.focusables()[this.prevFocusableIndex()] || this.lastFocusable() },
    nextFocusableIndex() { return (this.focusables().indexOf(document.activeElement) + 1) % (this.focusables().length + 1) },
    prevFocusableIndex() { return Math.max(0, this.focusables().indexOf(document.activeElement)) -1 },
})
